import {ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {Countdown, EnterFromBottom, LeaveCollapse} from './notification.animation';
import {AjaxDownloadQueueItem, AjaxDownloadService} from '../ajax-download.service';
import {untilDestroyed} from 'ngx-take-until-destroy';
import {FadeInOutAnimation} from '@helpers/animations/fadeInOut.animation';

@Component({
    selector: 'app-generation-notification',
    templateUrl: './generation-notification.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./generation-notification.component.scss'],
    animations: [
        EnterFromBottom,
        LeaveCollapse,
        FadeInOutAnimation,
        Countdown,
    ]
})
export class GenerationNotificationComponent implements OnInit, OnDestroy {

    public showCountdown = false;

    constructor(
        private cd: ChangeDetectorRef,
    ) {

    }

    public wannaBeDestroyed = new Subject();

    public queueItem$: AjaxDownloadQueueItem;

    @HostBinding('@enterFromBottom') private _efb = EnterFromBottom;
    @HostBinding('@leaveCollapse') private _lc = LeaveCollapse;

    close() {
        this.queueItem$.complete();
    }

    ngOnInit() {
        this.queueItem$.pipe(
            untilDestroyed(this)
        ).subscribe({
            next: (state) => {
                if (state.downloaded) {
                    this.showCountdown = true;
                }

                this.cd.detectChanges();
            },
            complete: () => {
                this.wannaBeDestroyed.next();
            }
        });
    }

    download() {
        AjaxDownloadService.setQueueState(this.queueItem$, {
            downloaded: true
        });
    }

    onCountdownEnd() {
        this.close();
    }

    ngOnDestroy(): void {

    }
}
